import ctl from '@netlify/classnames-template-literals';

const containerStyle = ctl(`
  rounded-t-sm
  relative 
  w-64
  p-2
  m-0
  m-t-0
  bg-titan-white 
  text-waterspout
`);

const title = ctl(`
  w-full 
  text-left 
  flex 
  gap-2 
  items-center
`);

const sectionsContainerStyle = ctl(`
  flex
  flex-col
  gap-2
  absolute 
  top-full 
  left-0 
  bg-titan-white 
  w-[inherit]
  px-2
  py-2
  text-waterspout 
  overflow-auto 
  max-h-64 
  transition-opacity 
  duration-250
  shadow-md
  ease-in-out`);

export default {
  containerStyle,
  title,
  sectionsContainerStyle,
};
